/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareLabelValuePair
 */
export interface SterWebsiteModelPriceCompareLabelValuePair {
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceCompareLabelValuePair
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceCompareLabelValuePair
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceCompareLabelValuePair
   */
  helpText?: string;
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareLabelValuePair>}
   * @memberof SterWebsiteModelPriceCompareLabelValuePair
   */
  children?: Array<SterWebsiteModelPriceCompareLabelValuePair>;
}

export function SterWebsiteModelPriceCompareLabelValuePairFromJSON(
  json: any
): SterWebsiteModelPriceCompareLabelValuePair {
  return SterWebsiteModelPriceCompareLabelValuePairFromJSONTyped(json, false);
}

export function SterWebsiteModelPriceCompareLabelValuePairFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareLabelValuePair {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    label: json["label"],
    value: json["value"],
    helpText: !exists(json, "helpText") ? undefined : json["helpText"],
    children: !exists(json, "children")
      ? undefined
      : (json["children"] as Array<any>).map(
          SterWebsiteModelPriceCompareLabelValuePairFromJSON
        ),
  };
}

export function SterWebsiteModelPriceCompareLabelValuePairToJSON(
  value?: SterWebsiteModelPriceCompareLabelValuePair | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    label: value.label,
    value: value.value,
    helpText: value.helpText,
    children:
      value.children === undefined
        ? undefined
        : (value.children as Array<any>).map(
            SterWebsiteModelPriceCompareLabelValuePairToJSON
          ),
  };
}
